module.exports = require("core-js/modules/es.string.pad-start.js");